import { render } from "./CaseBuddy.vue?vue&type=template&id=3efd44e6&scoped=true"
import script from "./CaseBuddy.vue?vue&type=script&lang=js"
export * from "./CaseBuddy.vue?vue&type=script&lang=js"

import "./CaseBuddy.vue?vue&type=style&index=0&id=3efd44e6&scoped=true&lang=css"
import "../assets/css/case-buddy.css?vue&type=style&index=1&id=3efd44e6&scoped=true&lang=css&external"
import "./CaseBuddy.vue?vue&type=style&index=2&id=3efd44e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efd44e6"]])

export default __exports__